import { Button, Group, LoadingOverlay, Modal, Text } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import EmailPreviewer from "./EmailPreviewer";
import { useDisclosure } from "@mantine/hooks";
import { useMemo, useState } from "react";
import { IconExternalLink, IconEye } from "@tabler/icons-react";
import BackButton from "./BackButton";
import { findWorkflow } from "../../api/WorkflowAPI";
import { useLeadsSheetStore } from "../../stores/LeadsStore";
import { Link } from "react-router-dom";

const EmailModalPreviewPrm = ({ prog_id, step_id, html, defaultCurrent }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const [opened, { open, close }] = useDisclosure();
  const [modelId, setModelId] = useState(null);
  const [modelName, setModelName] = useState(null);
  const [signId, setSignId] = useState(null);
  const currentInSheet = useLeadsSheetStore((s) => s.current);

  const current = useMemo(
    () => defaultCurrent || currentInSheet,
    [currentInSheet, defaultCurrent]
  );

  const handleOpen = () => {
    if (html) {
      return open();
    }

    setLoading(true);
    let workflow_id = current.programmations.find(
      (x) => x.programmation_id === prog_id
    )?.workflow_id;

    if (workflow_id) {
      findWorkflow(workflow_id)
        .then((res) => {
          let workflowProfile = res.data.workflow_profile;

          let step = workflowProfile.steps.find(
            (x) => x.step_id.id === step_id
          );

          let model_id = step.model_id;
          let model_name = step.model_name;
          let signature_id = step.signature_id;

          setModelId(model_id);
          setModelName(model_name);
          setSignId(signature_id);
          open();
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <>
      <Button
        variant="light"
        onClick={handleOpen}
        leftSection={<IconEye size={18} />}
        radius={"md"}
        loading={loading}
      >
        {lang.components.email_preview.button_label}
      </Button>
      <Modal
        opened={opened}
        onClose={close}
        title={
          html ? (
            <Text>{lang.components.email_preview.email_title}</Text>
          ) : (
            <Text>
              {lang.components.email_preview.email_title} :{" "}
              <b>
                {" "}
                {modelName} #{modelId}{" "}
              </b>
            </Text>
          )
        }
        size={"xl"}
        centered
      >
        <LoadingOverlay visible={loading} />
        <EmailPreviewer
          model_id={modelId}
          html={html}
          disableSubject={!!html}
          iframeHeight={"50vh"}
          paperShadow="none"
          signatureId={signId}
          contact={current}
          prog_id={prog_id}
        />

        <Group justify="end" mt={"md"}>
          <BackButton onClick={close} size="md" />

          {!html && (
            <Button
              component={Link}
              to={"/models/email/" + modelId}
              rightSection={<IconExternalLink size={18} />}
              size="md"
              target="_blank"
            >
              {lang.components.email_preview.view_model}
            </Button>
          )}
        </Group>
      </Modal>
    </>
  );
};

export default EmailModalPreviewPrm;
